import React from "react";

import {
  GOVGR_ADMIN_FOOTER,
  GOVGR_ADMIN_WIDTH_CONTAINER,
  GOVGR_FOOTER_CONTENT,
  GOVGR_FOOTER_GOVERMENT_LOGO,
  GOVGR_FOOTER_LICENT_DESCRIPTION,
  GOVGR_FOOTER_META,
  GOVGR_FOOTER_META_ITEM,
  GOVGR_FOOTER_META_ITEM_GROW,
  GOVGR_VISUALLY_HIDDEN,
} from "../../conf/styles/GovGrDrawerMenu";
import GovGrFooterLogo from "../icons/footer-logo.svg";

const Footer = () => {
  return (
    <footer className={`${GOVGR_ADMIN_FOOTER} p-0`} role="contentinfo">
      <div className={`${GOVGR_ADMIN_WIDTH_CONTAINER} p-0`}>
        <div className={GOVGR_FOOTER_META}>
          <div
            className={`${GOVGR_FOOTER_META_ITEM} ${GOVGR_FOOTER_META_ITEM_GROW}`}
          >
            <div className={GOVGR_FOOTER_CONTENT}>
              <p className={`${GOVGR_FOOTER_LICENT_DESCRIPTION} m-0`}>
                © Copyright 2022 - Υλοποίηση από το{" "}
                <a
                  href="https://mindigital.gr/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="govgr-link"
                >
                  Υπουργείο Ψηφιακής Διακυβέρνησης
                  <span className={GOVGR_VISUALLY_HIDDEN}>
                    (ανοίγει σε καινούρια καρτέλα)
                  </span>
                </a>
              </p>
            </div>
          </div>
          <div className={`${GOVGR_FOOTER_META_ITEM}`}>
            <img
              className={`${GOVGR_FOOTER_GOVERMENT_LOGO} mt-4 mb-0`}
              src={GovGrFooterLogo}
              alt="GovGrFooterLogo"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
